import isCategoryGridView from './category-grid'

const ENTRY_KEY = 'pomeloWorkwearReturn'
const MAX_AGE = 5 * 60 * 1000
const CARD_SELECTOR = '.workwear-grid .product-item'
let savedReturn = null
let sequence = 0

const isSameLocaleProductPath = (path, destination) => {
  const localePath = path?.match(/^\/[^/?#]+\/[^/?#]+\//)?.[0]
  return Boolean(
    localePath &&
      destination?.startsWith(localePath) &&
      /^\/[^/?#]+\/[^/?#]+\/[^?#]+\.html(?:[?#]|$)/.test(destination),
  )
}

const getContext = ({ filter, sort, internationalization, customerId, view }) =>
  JSON.stringify({ filter, sort, internationalization, customerId, view })

export function clearWorkwearReturn() {
  savedReturn = null
}

export function rememberWorkwearReturn({
  enabled,
  path,
  destination,
  props,
  startPageNo,
}) {
  clearWorkwearReturn()
  if (
    !enabled ||
    typeof window === 'undefined' ||
    !isSameLocaleProductPath(path, destination) ||
    !props.categoryProducts?.products?.length ||
    props.categoryProducts.sub_categories?.length ||
    props.productsFetching ||
    window.history.state?.as !== path
  ) {
    return
  }

  const entryId = `${Date.now()}:${sequence}`
  sequence += 1
  try {
    // Preserve Next's route/options and the URL; mark only this history entry.
    window.history.replaceState(
      { ...window.history.state, [ENTRY_KEY]: entryId },
      '',
    )
  } catch (error) {
    return
  }

  const cards = Array.from(document.querySelectorAll(CARD_SELECTOR))
  const index = cards.findIndex((card) => {
    const box = card.getBoundingClientRect()
    return box.bottom > 0 && box.top < window.innerHeight
  })
  savedReturn = {
    entryId,
    path,
    destination,
    savedAt: Date.now(),
    context: getContext(props),
    products: props.categoryProducts,
    category: props.category,
    startPageNo,
    scrollY: window.scrollY || window.pageYOffset || 0,
    anchor:
      index < 0
        ? null
        : { index, top: cards[index].getBoundingClientRect().top },
  }
}

export function canRestoreWorkwearReturn(saved, props) {
  return Boolean(
    saved &&
      saved.products === props.categoryProducts &&
      saved.category === props.category &&
      !props.productsFetching &&
      saved.context === getContext(props),
  )
}

export function takeWorkwearReturn({ asPath, fromPath, state }) {
  const saved = savedReturn
  // On Back, the browser has already selected the target entry while Next 7
  // still exposes the product route. A normal link still has the product entry.
  const entry = typeof window !== 'undefined' && window.history.state
  const returning =
    saved &&
    entry?.[ENTRY_KEY] === saved.entryId &&
    entry?.as === asPath &&
    fromPath === saved.destination
  clearWorkwearReturn()
  const props = {
    category: state.category?.payload,
    categoryProducts: state.products?.payload,
    productsFetching: state.products?.isFetching,
    filter: state.filter,
    sort: state.sort,
    internationalization: state.internationalization,
    view: state.visibility?.view,
    customerId: state.auth?.user?.id_customer,
  }
  if (
    !returning ||
    !saved ||
    saved.path !== asPath ||
    Date.now() - saved.savedAt > MAX_AGE ||
    !isCategoryGridView(props) ||
    !canRestoreWorkwearReturn(saved, props)
  ) {
    return null
  }
  return saved
}

export function restoreWorkwearScroll(saved) {
  let frame
  const cancel = () => {
    window.cancelAnimationFrame(frame)
    window.removeEventListener('wheel', cancel)
    window.removeEventListener('touchstart', cancel)
    window.removeEventListener('keydown', cancel)
  }
  window.addEventListener('wheel', cancel, { passive: true })
  window.addEventListener('touchstart', cancel, { passive: true })
  window.addEventListener('keydown', cancel)
  // Run after mount and route-complete scroll resets, without a retry loop.
  frame = window.requestAnimationFrame(() => {
    cancel()
    const card =
      saved.anchor &&
      document.querySelectorAll(CARD_SELECTOR)[saved.anchor.index]
    const top = card
      ? window.scrollY + card.getBoundingClientRect().top - saved.anchor.top
      : saved.scrollY
    window.scrollTo(0, Math.max(0, top))
  })
  return cancel
}
